import React from 'react';
import { Link } from 'react-router-dom';
import TrailerFinder from './TrailerFinder';
import './MainTrailers.css';

interface TrailerType {
  title: string;
  description: string;
  link: string;
}

const MainTrailers: React.FC = () => {
  const trailerTypes: TrailerType[] = [
    {
      title: "Aluminum Trailers",
      description: "Durable, affordable and lightweight. Count on our aluminum trailers to support your boat for years to come.",
      link: "/trailers/aluminum"
    },
    {
      title: "Bunk Trailers", 
      description: "If you're looking for an affordable and easy-to-maintain trailer, bunk trailers may be for you.",
      link: "/trailers/bunk"
    },
    {
      title: "Commander Line",
      description: "Venture Trailers Commander Series is built for the long haul with premium features that every experienced boater could want. Each comes equipped with sleek, high-end features that come standard with every model.",
      link: "/trailers/commander"
    },
    {
      title: "Galvanized",
      description: "Avoid corrosion on all your excursions with a galvanized trailer. Our complete galvanized trailer line comes in a range of sizes and configurations.",
      link: "/trailers/galvanized"
    },
    {
      title: "Personal Watercraft Trailer",
      description: "Secure your PWC with a Venture Trailers Personal Watercraft Trailer. Our single or tandem trailers make transporting a breeze.",
      link: "/trailers/pwc"
    },
    {
      title: "Pontoon Trailers",
      description: "We have a wide variety of pontoon trailers that support your boat, from 16 feet to 26 feet in length.",
      link: "/trailers/pontoon"
    },
    {
      title: "Roller Trailers",
      description: "Roller trailers are perfect for easy loading and unloading on shallow ramps or low tides.",
      link: "/trailers/roller"
    },
    {
      title: "Skiff and Jon Boat Trailers",
      description: "Perfect for small boats, our Skiff and Jon Boat Trailers are made to carry lightweight loads for seamless loading and launching.",
      link: "/trailers/skiff"
    },
    {
      title: "Tritoon Trailers",
      description: "Get the support your boat needs with our strong and dependable tritoon trailers.",
      link: "/trailers/tritoon"
    },
    {
      title: "Boat Trailer Accessories",
      description: "Give your trailer the upgrade it deserves. Find out more about Venture's full line of boat trailer accessories including aluminum wheels, dual well tongue jacks, electric brakes, stainless steel brakes, keel rollers, LED lights, bunk covers and more.",
      link: "/trailers/accessories"
    }
  ];

  return (
    <section className="main-trailers py-5" id="main-trailers">
      <div className="container">
        {/* Interactive Trailer Finder */}
        <TrailerFinder />

        {/* Trailer Types Grid */}
        <div className="trailer-types-grid">
          {trailerTypes.map((trailer, index) => (
            <div key={index} className="trailer-type-card">
              <Link to={trailer.link} className="trailer-type-link">
                <h3>{trailer.title}</h3>
                <p>{trailer.description}</p>
                <div className="learn-more">
                  <span>Learn More →</span>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="trailers-cta">
          <h3>Ready to Find Your Perfect Trailer?</h3>
          <p>
            Contact Fast Boat Trailers today for expert advice, personalized recommendations, 
            and competitive pricing on all Venture trailer models.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-large">Get Quote Today</Link>
            <Link to="/tips" className="btn btn-secondary">View Trailer Tips</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainTrailers;